import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sideBarSearchFilter'
})
export class SideBarSearchFilterPipe implements PipeTransform {
  searchText;
  transform(items:any, searchText: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }

    this.searchText = searchText;
    searchText = searchText.toLocaleLowerCase();

    return items.filter(item =>{
      return item.name.toLowerCase().includes(searchText);
    });
  }

  isIncludes(element,index,array){
    return element.name.toLowerCase().includes(this.searchText);
  }

}
